import { Check } from '@mui/icons-material'
import { Step, StepConnector, stepConnectorClasses, StepIconProps, StepLabel, Stepper, styled } from '@mui/material'
import React from 'react'

//#region Q
const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)'
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#26b6ff'
    }
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#26b6ff'
    }
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1
  }
}))

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#26b6ff'
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#26b6ff',
    zIndex: 1,
    fontSize: 18
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor'
  }
}))

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className } = props

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? <Check className='QontoStepIcon-completedIcon' /> : <div className='QontoStepIcon-circle' />}
    </QontoStepIconRoot>
  )
}
//#endregion

interface VehicleCheckInStepperProps {
  activeStep: number
}

export default function VehicleCheckInStepper({ activeStep }: VehicleCheckInStepperProps) {
  return (
    <Stepper activeStep={activeStep}>
      <Step completed={activeStep > 0}>
        <StepLabel>Vehicle Details</StepLabel>
      </Step>

      <Step completed={activeStep > 1}>
        <StepLabel>Print Labels</StepLabel>
      </Step>

      <Step completed={activeStep > 2}>
        <StepLabel>Check-In Photos</StepLabel>
      </Step>

      <Step completed={activeStep > 3}>
        <StepLabel>Check-In Review</StepLabel>
      </Step>
    </Stepper>
  )
}
